import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { KnowledgeBase } from '@feedyou/schema'
import { FormValidation } from '@rjsf/utils'

import { save } from './actions/save'
import { useSettingsPopupState } from '../hooks'
import { SettingsPopup } from '../SettingsPopup'
import { ModalDescriptorForType } from '../../../store/modals'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { useKnowledgeBaseById } from '../../../store/botNlp/hooks'
import { useOpenModalOpenSection } from '../../../store/modals/hooks/useOpenModalOpenSection'
import { botFlowSelector } from '../../../store/flow/selectors/botFlowSelector'
import { useSchema } from './hooks/useSchema'
import { useUiSchema } from './hooks/useUiSchema'

type Props = { modalDescriptor: ModalDescriptorForType<'knowledge_base_settings'> }

export const KnowledgeBaseSettingsPopup: React.FC<Props> = memo(({ modalDescriptor }) => {
  const schema = useSchema()
  const uiSchema = useUiSchema()
  const dispatch = useDispatch()
  const knowledgeBase = useKnowledgeBaseById(modalDescriptor.knowledgeBaseId)
  const openSection = useOpenModalOpenSection() ?? 'form'
  const flow = useSelector(botFlowSelector)
  const settingsPopupState = useSettingsPopupState(() => knowledgeBase || {}, [openSection])

  const allKnowledgeBases = flow?.knowledgeBases || []
  const close = () => dispatch(modalsActions.closeModal())

  return (
    <SettingsPopup
      className="no-error-panel"
      close={close}
      openSection={openSection}
      formData={settingsPopupState.formData}
      schema={schema}
      uiSchema={uiSchema}
      onChange={settingsPopupState.onFormDataChange}
      initialFormData={settingsPopupState.initialFormData}
      customTabNames={{ form: 'Knowledge Base Settings' }}
      save={async formData => {
        await dispatch(
          save({
            formData: formData as KnowledgeBase,
            initialFormData: (settingsPopupState.initialFormData || {}) as KnowledgeBase
          })
        )
        close()
      }}
      validateSchema={(updatedKb: any, errors: FormValidation<any>) => {
        const initialKb = settingsPopupState.initialFormData as Partial<KnowledgeBase>
        if (
          initialKb?.id &&
          initialKb.id !== updatedKb.id &&
          allKnowledgeBases.find(({ id }) => id === updatedKb.id)
        ) {
          errors.addError('Knowledge Base ID already exists.')
        }

        return errors
      }}
    />
  )
})
